<script lang="ts">
  export let label: string | null = null;
  export let checked: boolean = false;
  export let disabled: boolean = false;
  export let onChange = () => {};
  export let onClick = () => {};

  $: inputClass = `alii-checkbox appearance-none border-1 text-primary-500 border-surface-600 rounded-md w-[20px] h-[20px] cursor-pointer border-solid
  disabled:cursor-not-allowed
  disabled:bg-surface-600
  disabled:border-surface-600
  checked:bg-primary-500
  hover:bg-secondary-500
  focus:ring-primary-500
  border-primary-500
  bg-primary-500
  }`;
</script>

{#if label}
  <label class="flex items-center space-x-2">
    <input class={inputClass} type="checkbox" bind:checked on:change={onChange} on:click={onClick} {disabled} />
    <p>{label}</p>
  </label>
{:else}
  <input class={inputClass} type="checkbox" on:change={onChange} on:click={onClick} bind:checked {disabled} />
{/if}

<style lang="postcss"></style>
